"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function AdvSearchRentRange({
  rangeSliderSlot = "",
  textMax = "$10,000",
  textMin = "$",
}) {
  return (
    <Block className={"rheostatcontainer-sc-j148cl-0 hovjsq"} tag={"div"}>
      <Block className={" adv-search-lable"} tag={"div"}>
        {"Price Range"}
      </Block>
      <Block className={"div-block-79"} tag={"div"}>
        {rangeSliderSlot ?? (
          <Block className={"rheostat rheostat_1"} tag={"div"}>
            <Block className={"defaultbackground"} tag={"div"} />
            <Block className={"handlecontainer"} tag={"div"}>
              <Link
                button={true}
                className={"defaulthandle_handle"}
                options={{
                  href: "#",
                }}
              />
              <Link
                button={true}
                className={"defaulthandle_handle right"}
                options={{
                  href: "#",
                }}
              />
            </Block>
            <Block className={"defaultprogressbar_progressbar"} tag={"div"} />
          </Block>
        )}
      </Block>
      <Block className={"div-block-76"} tag={"div"}>
        <Block className={"range-slide-price-text"} tag={"div"}>
          <Block className={"range-slider-text"} tag={"div"}>
            {textMin}
          </Block>
        </Block>
        <Block className={"range-slide-price-text"} tag={"div"}>
          <Block className={"range-slider-text"} tag={"div"}>
            {textMax}
          </Block>
        </Block>
      </Block>
    </Block>
  );
}
